import Component from './shareholder-form';
export default Component;
